import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "5",
      cy: "6",
      r: "2",
      class: "st0"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "19",
      cy: "18",
      r: "2",
      class: "st0"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17 18h-1c-5 0-3-12-8-12H7",
      class: "st0"
    }, null, -1)
  ]))]))
}
export default { render: render }